import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { RouteFallback } from './components/utils/RouteFallback';
const Landing = lazy(() => import('./pages/Landing').then((m) => ({ default: m.Landing })));
const Features = lazy(() => import('./pages/Features').then((m) => ({ default: m.Features })));
const ForChambers = lazy(() => import('./pages/ForChambers').then((m) => ({ default: m.ForChambers })));
const ForMembers = lazy(() => import('./pages/ForMembers').then((m) => ({ default: m.ForMembers })));
const ForGovernments = lazy(() => import('./pages/ForGovernments').then((m) => ({ default: m.ForGovernments })));
const Pricing = lazy(() => import('./pages/Pricing').then((m) => ({ default: m.Pricing })));
const DocsPortal = lazy(() => import('./pages/DocsPortal').then((m) => ({ default: m.DocsPortal })));
const Community = lazy(() => import('./pages/Community').then((m) => ({ default: m.Community })));
const About = lazy(() => import('./pages/About').then((m) => ({ default: m.About })));
const Partners = lazy(() => import('./pages/Partners').then((m) => ({ default: m.Partners })));
const Press = lazy(() => import('./pages/Press').then((m) => ({ default: m.Press })));
const Contact = lazy(() => import('./pages/Contact').then((m) => ({ default: m.Contact })));
const Membership = lazy(() => import('./pages/Membership').then((m) => ({ default: m.Membership })));
const TradeTrust = lazy(() => import('./pages/TradeTrust').then((m) => ({ default: m.TradeTrust })));
const DataInsights = lazy(() => import('./pages/DataInsights').then((m) => ({ default: m.DataInsights })));
const ApiReference = lazy(() => import('./pages/ApiReference').then((m) => ({ default: m.ApiReference })));
const Architecture = lazy(() => import('./pages/Architecture').then((m) => ({ default: m.Architecture })));
const Roadmap = lazy(() => import('./pages/Roadmap').then((m) => ({ default: m.Roadmap })));
const Dashboard = lazy(() => import('./pages/platform/Dashboard').then((m) => ({ default: m.Dashboard })));
const Members = lazy(() => import('./pages/platform/Members').then((m) => ({ default: m.Members })));
const Events = lazy(() => import('./pages/platform/Events').then((m) => ({ default: m.Events })));
const Advocacy = lazy(() => import('./pages/platform/Advocacy').then((m) => ({ default: m.Advocacy })));
const Trade = lazy(() => import('./pages/platform/Trade').then((m) => ({ default: m.Trade })));
const Marketplace = lazy(() => import('./pages/platform/Marketplace').then((m) => ({ default: m.Marketplace })));
const Billing = lazy(() => import('./pages/platform/Billing').then((m) => ({ default: m.Billing })));
const Settings = lazy(() => import('./pages/platform/Settings').then((m) => ({ default: m.Settings })));
const Analytics = lazy(() => import('./pages/platform/Analytics').then((m) => ({ default: m.Analytics })));
const Training = lazy(() => import('./pages/platform/Training').then((m) => ({ default: m.Training })));
const Grants = lazy(() => import('./pages/platform/Grants').then((m) => ({ default: m.Grants })));
const Signup = lazy(() => import('./pages/platform/Signup').then((m) => ({ default: m.Signup })));
const TradeCoApplication = lazy(() => import('./pages/platform/TradeCoApplication').then((m) => ({ default: m.TradeCoApplication })));
const MemberProfile = lazy(() => import('./pages/platform/MemberProfile').then((m) => ({ default: m.MemberProfile })));
const EventCheckin = lazy(() => import('./pages/platform/EventCheckin').then((m) => ({ default: m.EventCheckin })));
const InvoiceDetail = lazy(() => import('./pages/platform/InvoiceDetail').then((m) => ({ default: m.InvoiceDetail })));
const Directory = lazy(() => import('./pages/platform/Directory').then((m) => ({ default: m.Directory })));
const Notifications = lazy(() => import('./pages/platform/Notifications').then((m) => ({ default: m.Notifications })));
const AiConcierge = lazy(() => import('./pages/platform/AiConcierge').then((m) => ({ default: m.AiConcierge })));
const EventCreate = lazy(() => import('./pages/platform/EventCreate').then((m) => ({ default: m.EventCreate })));
const Moderation = lazy(() => import('./pages/platform/Moderation').then((m) => ({ default: m.Moderation })));
const JobBoard = lazy(() => import('./pages/platform/JobBoard').then((m) => ({ default: m.JobBoard })));
const Sponsors = lazy(() => import('./pages/platform/Sponsors').then((m) => ({ default: m.Sponsors })));
const DataRoom = lazy(() => import('./pages/platform/DataRoom').then((m) => ({ default: m.DataRoom })));
const BulkImport = lazy(() => import('./pages/platform/BulkImport').then((m) => ({ default: m.BulkImport })));
const EmailTemplates = lazy(() => import('./pages/platform/EmailTemplates').then((m) => ({ default: m.EmailTemplates })));
const ExpoFloor = lazy(() => import('./pages/platform/ExpoFloor').then((m) => ({ default: m.ExpoFloor })));
const Webhooks = lazy(() => import('./pages/platform/Webhooks').then((m) => ({ default: m.Webhooks })));
const Reports = lazy(() => import('./pages/platform/Reports').then((m) => ({ default: m.Reports })));
const Onboarding = lazy(() => import('./pages/platform/Onboarding').then((m) => ({ default: m.Onboarding })));
const PollCreate = lazy(() => import('./pages/platform/PollCreate').then((m) => ({ default: m.PollCreate })));
const GrantApplication = lazy(() => import('./pages/platform/GrantApplication').then((m) => ({ default: m.GrantApplication })));
const TicketTransfer = lazy(() => import('./pages/platform/TicketTransfer').then((m) => ({ default: m.TicketTransfer })));
const VendorOnboarding = lazy(() => import('./pages/platform/VendorOnboarding').then((m) => ({ default: m.VendorOnboarding })));
const CoVerification = lazy(() => import('./pages/platform/CoVerification').then((m) => ({ default: m.CoVerification })));
const NotFound = lazy(() => import('./pages/NotFound').then((m) => ({ default: m.NotFound })));
const Privacy = lazy(() => import('./pages/legal/Privacy').then((m) => ({ default: m.Privacy })));
const Terms = lazy(() => import('./pages/legal/Terms').then((m) => ({ default: m.Terms })));
const Security = lazy(() => import('./pages/legal/Security').then((m) => ({ default: m.Security })));
import { ScrollToTop } from './components/utils/ScrollToTop';
const EventDetail = lazy(() => import('./pages/platform/EventDetail').then((m) => ({ default: m.EventDetail })));
const IssueDetail = lazy(() => import('./pages/platform/IssueDetail').then((m) => ({ default: m.IssueDetail })));
const CourseDetail = lazy(() => import('./pages/platform/CourseDetail').then((m) => ({ default: m.CourseDetail })));
const RfpDetail = lazy(() => import('./pages/platform/RfpDetail').then((m) => ({ default: m.RfpDetail })));
const MemberDetail = lazy(() => import('./pages/platform/MemberDetail').then((m) => ({ default: m.MemberDetail })));
const DisputeDetail = lazy(() => import('./pages/platform/DisputeDetail').then((m) => ({ default: m.DisputeDetail })));
const AiMatchmaking = lazy(() => import('./pages/platform/AiMatchmaking').then((m) => ({ default: m.AiMatchmaking })));
const PolicyBriefDrafter = lazy(() => import('./pages/platform/PolicyBriefDrafter').then((m) => ({ default: m.PolicyBriefDrafter })));
const DataCatalog = lazy(() => import('./pages/platform/DataCatalog').then((m) => ({ default: m.DataCatalog })));
const EconomicIndicators = lazy(() => import('./pages/platform/EconomicIndicators').then((m) => ({ default: m.EconomicIndicators })));
const UsageMetering = lazy(() => import('./pages/platform/UsageMetering').then((m) => ({ default: m.UsageMetering })));
const SreDashboard = lazy(() => import('./pages/platform/SreDashboard').then((m) => ({ default: m.SreDashboard })));
const DbaOperations = lazy(() => import('./pages/platform/DbaOperations').then((m) => ({ default: m.DbaOperations })));
const SecurityOps = lazy(() => import('./pages/platform/SecurityOps').then((m) => ({ default: m.SecurityOps })));
const IncidentManagement = lazy(() => import('./pages/platform/IncidentManagement').then((m) => ({ default: m.IncidentManagement })));
const DataEngineering = lazy(() => import('./pages/platform/DataEngineering').then((m) => ({ default: m.DataEngineering })));
const JobDetail = lazy(() => import('./pages/platform/JobDetail').then((m) => ({ default: m.JobDetail })));
const GrantDetail = lazy(() => import('./pages/platform/GrantDetail').then((m) => ({ default: m.GrantDetail })));
const RfpCreate = lazy(() => import('./pages/platform/RfpCreate').then((m) => ({ default: m.RfpCreate })));
const Search = lazy(() => import('./pages/platform/Search').then((m) => ({ default: m.Search })));
const SponsorDetail = lazy(() => import('./pages/platform/SponsorDetail').then((m) => ({ default: m.SponsorDetail })));
const BillingPlans = lazy(() => import('./pages/platform/BillingPlans').then((m) => ({ default: m.BillingPlans })));
const AuditLog = lazy(() => import('./pages/platform/AuditLog').then((m) => ({ default: m.AuditLog })));
const PartnerPortal = lazy(() => import('./pages/platform/PartnerPortal').then((m) => ({ default: m.PartnerPortal })));
const ApiKeys = lazy(() => import('./pages/platform/ApiKeys').then((m) => ({ default: m.ApiKeys })));
const PersonDetail = lazy(() => import('./pages/platform/PersonDetail').then((m) => ({ default: m.PersonDetail })));
const VendorDetail = lazy(() => import('./pages/platform/VendorDetail').then((m) => ({ default: m.VendorDetail })));
const SloDetail = lazy(() => import('./pages/platform/SloDetail').then((m) => ({ default: m.SloDetail })));
const CanaryDetail = lazy(() => import('./pages/platform/CanaryDetail').then((m) => ({ default: m.CanaryDetail })));
const DbRoleDetail = lazy(() => import('./pages/platform/DbRoleDetail').then((m) => ({ default: m.DbRoleDetail })));
const PiiColumnDetail = lazy(() => import('./pages/platform/PiiColumnDetail').then((m) => ({ default: m.PiiColumnDetail })));
const DbTableDetail = lazy(() => import('./pages/platform/DbTableDetail').then((m) => ({ default: m.DbTableDetail })));
const SlowQueryDetail = lazy(() => import('./pages/platform/SlowQueryDetail').then((m) => ({ default: m.SlowQueryDetail })));
const ApiKeyDetail = lazy(() => import('./pages/platform/ApiKeyDetail').then((m) => ({ default: m.ApiKeyDetail })));
import { Providers } from './providers';
import { RequireAuth } from './components/guards/RequireAuth';
import { RouteAccessGate } from './components/guards/RouteAccessGate';
import type { UserRole } from './types';

const ADMIN_ROLES: UserRole[] = ['IT_ADMIN'];
const BILLING_ROLES: UserRole[] = ['CHAMBER_CEO', 'MEMBERSHIP_MANAGER', 'IT_ADMIN'];
export function App() {
  return (
    <Providers>
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen flex flex-col bg-background font-heading antialiased">
        <Header />
        <RouteAccessGate>
        <Suspense fallback={<RouteFallback />}>
        <Routes>
          {/* Marketing pages */}
          <Route path="/" element={<Landing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/for-chambers" element={<ForChambers />} />
          <Route path="/for-members" element={<ForMembers />} />
          <Route path="/for-governments" element={<ForGovernments />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/docs" element={<DocsPortal />} />
          <Route path="/verify-co" element={<CoVerification />} />
          <Route path="/community" element={<Community />} />
          <Route path="/about" element={<About />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/press" element={<Press />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/trade-trust" element={<TradeTrust />} />
          <Route path="/data-insights" element={<DataInsights />} />
          <Route path="/api-reference" element={<ApiReference />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/roadmap" element={<Roadmap />} />

          {/* Legal pages */}
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/security" element={<Security />} />

          {/* Platform pages */}
          <Route element={<RequireAuth />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/members" element={<Members />} />
            <Route path="/events" element={<Events />} />
            <Route path="/events/checkin" element={<EventCheckin />} />
            <Route path="/advocacy" element={<Advocacy />} />
            <Route path="/trade" element={<Trade />} />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/analytics" element={<Analytics />} />
            <Route path="/training" element={<Training />} />
            <Route path="/grants" element={<Grants />} />
            <Route
              path="/trade/co-application"
              element={<TradeCoApplication />} />
            
            <Route path="/profile" element={<MemberProfile />} />
            <Route path="/directory" element={<Directory />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/concierge" element={<AiConcierge />} />
            <Route path="/events/create" element={<EventCreate />} />
            <Route path="/jobs" element={<JobBoard />} />
            <Route path="/sponsors" element={<Sponsors />} />
            <Route path="/data-room" element={<DataRoom />} />
            <Route path="/events/expo" element={<ExpoFloor />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/onboarding" element={<Onboarding />} />
            <Route path="/advocacy/poll-create" element={<PollCreate />} />
            <Route path="/grants/apply" element={<GrantApplication />} />
            <Route path="/events/transfer" element={<TicketTransfer />} />
            <Route
              path="/marketplace/vendor-apply"
              element={<VendorOnboarding />} />
            
            <Route path="/events/:id" element={<EventDetail />} />
            <Route path="/advocacy/issues/:id" element={<IssueDetail />} />
            <Route path="/training/:id" element={<CourseDetail />} />
            <Route path="/marketplace/rfp/:id" element={<RfpDetail />} />
            <Route path="/members/:id" element={<MemberDetail />} />
            <Route path="/marketplace/disputes/:id" element={<DisputeDetail />} />
            <Route path="/concierge/matchmaking" element={<AiMatchmaking />} />
            <Route
              path="/advocacy/brief-drafter"
              element={<PolicyBriefDrafter />} />
            
            <Route path="/analytics/catalog" element={<DataCatalog />} />
            <Route
              path="/analytics/indicators"
              element={<EconomicIndicators />} />
            
            <Route
              path="/analytics/data-engineering"
              element={<DataEngineering />} />
            
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/grants/:id" element={<GrantDetail />} />
            <Route path="/marketplace/rfp-create" element={<RfpCreate />} />
            <Route path="/search" element={<Search />} />
            <Route path="/sponsors/:id" element={<SponsorDetail />} />
            <Route path="/people/:id" element={<PersonDetail />} />
            <Route path="/marketplace/vendors/:id" element={<VendorDetail />} />

            <Route element={<RequireAuth roles={BILLING_ROLES} showAccessDenied />}>
              <Route path="/billing" element={<Billing />} />
              <Route path="/billing/invoice" element={<InvoiceDetail />} />
              <Route path="/billing/usage" element={<UsageMetering />} />
              <Route path="/billing/plans" element={<BillingPlans />} />
            </Route>

            <Route element={<RequireAuth roles={ADMIN_ROLES} showAccessDenied />}>
              <Route path="/settings" element={<Settings />} />
              <Route path="/moderation" element={<Moderation />} />
              <Route path="/import" element={<BulkImport />} />
              <Route path="/email-templates" element={<EmailTemplates />} />
              <Route path="/webhooks" element={<Webhooks />} />
              <Route path="/settings/sre" element={<SreDashboard />} />
              <Route path="/settings/dba" element={<DbaOperations />} />
              <Route path="/settings/security" element={<SecurityOps />} />
              <Route path="/settings/incidents" element={<IncidentManagement />} />
              <Route path="/settings/audit" element={<AuditLog />} />
              <Route path="/partner-portal" element={<PartnerPortal />} />
              <Route path="/settings/api-keys" element={<ApiKeys />} />
              <Route path="/settings/sre/slo/:id" element={<SloDetail />} />
              <Route path="/settings/sre/canary/:id" element={<CanaryDetail />} />
              <Route
                path="/settings/security/roles/:id"
                element={<DbRoleDetail />} />
              
              <Route
                path="/settings/security/pii/:tableName/:columnName"
                element={<PiiColumnDetail />} />
              
              <Route
                path="/settings/dba/tables/:name"
                element={<DbTableDetail />} />
              
              <Route
                path="/settings/dba/queries/:queryId"
                element={<SlowQueryDetail />} />
              
              <Route path="/settings/api-keys/:id" element={<ApiKeyDetail />} />
            </Route>
          </Route>

          <Route path="/signup" element={<Signup />} />

          {/* Fallback */}
          <Route path="*" element={<NotFound />} />
        </Routes>
        </Suspense>
        </RouteAccessGate>
        <Footer />
      </div>
    </BrowserRouter>
    </Providers>);

}